import { gql, useMutation } from "@apollo/client";

export const MUTATION_DELETE_ACCESS_RIGHTS = gql`
  mutation deleteAccessRights($repoId: ID!, $contributors: [String!]) {
    deleteAccessRights(
      input: { repoId: $repoId, contributors: $contributors }
    ) {
      readers
      contributors
    }
  }
`;

export function useDeleteAccessRightsMutation() {
  const [
    deleteAccessRightsMutation,
    { loading: isLoadingDeleteMutation, error: errorDeleteMutation }
  ] = useMutation(MUTATION_DELETE_ACCESS_RIGHTS);

  return {
    deleteAccessRightsMutation,
    isLoadingDeleteMutation,
    errorDeleteMutation
  };
}
